import { createFileRoute, Link as TanstackLink } from '@tanstack/react-router';
import { HStack, linkStyles, Text, textVariants, VStack } from 'ui_2';
import { Route as rewards_route } from '@routes/rewards';
import { Route as giveaway_index_route } from '@routes/giveaways';
import { Route as giveaway_history_route } from '@routes/giveaways/history';
import { CurrentGiveaways } from '@src/components/giveaway/Giveaways';
import { HomePage } from '@src/components/layout/HomePage';
import { HomePageNav } from '@src/components/HomePageNav';
import { useViewTransition } from '@src/hooks/useViewTransition';
import { ArcadeStoreProductsForCountry } from '@src/components/store/ArcadeStoreProductsForCountry';

export const Route = createFileRoute('/')({
  staticData: {
    title: 'Home',
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { slideLeftFullPage } = useViewTransition();

  return (
    <HomePage>
      <VStack className='w-full gap-4'>
        <VStack className='gap-4'>
          <HStack className='w-full max-w-[450px] gap-4'>
            <HomePageNav toRoute={giveaway_history_route.to}>
              <Text>Giveaway Entries</Text>
              <HStack className='flex-grow' />
            </HomePageNav>
            <HomePageNav toRoute={rewards_route.to}>
              <Text>Store Items</Text>
              <HStack className='flex-grow' />
            </HomePageNav>
          </HStack>
          <VStack className='gap-12'>
            <VStack className='gap-4'>
              <HStack className='w-full items-center'>
                <Text font='bold-md' family='atak' className='hidden md:block'>
                  Giveaways
                </Text>
                <Text font='bold-xs' family='atak' className='block md:hidden'>
                  Giveaways
                </Text>
                <HStack className='flex-grow' />
                <TanstackLink
                  to={giveaway_index_route.to}
                  className={linkStyles({
                    variant: 'black',
                    className: textVariants({ font: 'sm' }),
                  })}
                  viewTransition={slideLeftFullPage}
                >
                  View All
                </TanstackLink>
              </HStack>
              <CurrentGiveaways />
            </VStack>
            <VStack className='gap-4'>
              <Text font='bold-md' family='atak' className='hidden md:block'>
                Shop Gift Cards
              </Text>
              <Text font='bold-xs' family='atak' className='block md:hidden'>
                Shop Gift Cards
              </Text>
              <ArcadeStoreProductsForCountry />
            </VStack>
          </VStack>
        </VStack>
      </VStack>
    </HomePage>
  );
}
